import {memoize} from '@sail/utils';
import urlToFullLocation from 'src/internal/urlToFullLocation';

import type {LocationReturn} from 'src/types';

function urlToLocation(url: string): LocationReturn {
  const location = urlToFullLocation(url);

  const search = Object.fromEntries(
    Object.entries(location.search).filter(([key]) => !key.startsWith('_')),
  );

  return Object.assign({}, location, {search});
}

export default memoize(urlToLocation);
